import { render } from "./index-startup.vue?vue&type=template&id=72a69842&scoped=true"
import script from "./index-startup.vue?vue&type=script&lang=js"
export * from "./index-startup.vue?vue&type=script&lang=js"

import "./index-startup.vue?vue&type=style&index=0&id=72a69842&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a69842"]])

export default __exports__